
export class ServiceLogModel {
  id: number;
  httpMethod: string;
  url: string;
  actionType: string;
  actionPayload: string;
  responseCode: string;
  responseDurationMs: string;
  traceId: string;
  spanId: string;
  datetime: string;


  public constructor(init?: Partial<ServiceLogModel>) {
    Object.assign(this, init);
  }
}
